import { ExternalEntryPath } from "@/types";

export const getExternalEntryPath = (): ExternalEntryPath => {
  const currentPath = window.location.pathname;
  if (currentPath.includes("contact-us")) {
    return "contact_us_page";
  }
  return "chat_online_menu";
};
